import { Theme } from '@ublend-npm/aulaui-core';

export const createStyles = (theme: Theme) => {
  const isDark = theme.palette.mode == 'dark';
  const { fontFamily } = theme.typography;
  const { primary } = theme.palette;

  return {
    actionWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '2px',
      color: primary.main,
      fontFamily,
    },
    actionDetails: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
    },
    actionIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    actionText: {
      fontSize: { xs: '12px', md: '15px' },
      fontWeight: '500',
    },
    actionMenuIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    actionButton: {
      color: primary.main,
    },
    menuOptions: {
      '& .MuiPaper-root': {
        backgroundColor: isDark ? '#363636 !important' : undefined,
        color: isDark ? '#ffffff' : undefined,
        width: '240px',
        marginTop: '4px',
      },
      '& .MuiMenu-paper': {
        backgroundColor: isDark ? '#363636 !important' : undefined,
      },
      '& .MuiPopover-paper': {
        backgroundColor: isDark ? '#363636 !important' : undefined,
      },
      '& .MuiMenu-list': {
        backgroundColor: isDark ? '#363636 !important' : undefined,
      },
      '& .MuiList-root': {
        backgroundColor: isDark ? '#363636 !important' : undefined,
      },
      '& .MuiMenuItem-root': {
        py: '0px',
        px: '6px',
      },
      '& .MuiListItemIcon-root': {
        height: '42px',
        width: '42px',
      },
      '& .MuiFormControlLabel-root': {
        m: '0px',
      },
      '& .MuiListItemText-primary': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
      },
    },
    menuPaper: {
      backgroundColor: isDark ? '#363636' : undefined,
      color: isDark ? '#ffffff' : undefined,
      width: '240px',
      marginTop: '4px',
    },
  };
};
